// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"baf51af2","lsc":"97d59441","others":"c19e59f4"}[chunkId] + ".chunk.js";
};